const StatCard = ({ title, value, icon, badge, badgeColor }) => (
  <div className="bg-white p-6 rounded-[2rem] shadow-sm relative overflow-hidden">
    <div className={`absolute top-4 left-4 text-xs font-bold px-2 py-1 rounded-lg ${badgeColor}`}>
      {badge}
    </div>
    <div className="text-3xl mb-4">{icon}</div>
    <div className="text-right">
      <p className="text-gray-400 text-sm font-medium">{title}</p>
      <h3 className="text-3xl font-black text-slate-800 mt-1">{value}</h3>
    </div>
  </div>
);


export default StatCard;